
export function MinValidator(min: number, customMessage=null) {
  return (control: any): { [key: string]: any } | null => {
    const isEmpty = control.nativeElement?.value==="";
    if (!isEmpty && (control.value || control.value===0) && control.value<min) {
      return { min: customMessage || `El valor debe ser mayor que ${min}` };
    }
    return null;
  };
}

export function MaxValidator(max: number, customMessage=null) {
  return (control: any): { [key: string]: any } | null => {
    const isEmpty = control.nativeElement?.value==="";
    if (!isEmpty && (control.value || control.value===0) && control.value>max) {
      return { max: customMessage || `El valor debe ser menor que ${max}` };
    }
    return null;
  };
}

export function MinMaxValidator(min:number,max: number, customMessage=null) {
  return (control: any): { [key: string]: any } | null => {
    const isEmpty = control.nativeElement?.value==="";
    if (!isEmpty && (control.value || control.value===0) && (control.value>max || control.value<min)) {
      if(min==max){
        return { minMax: customMessage || `El valor debe ser igual que ${min}` };
      }
      return { minMax: customMessage || `El valor debe estar entre ${min} y ${max}` };
    }
    return null;
  };
}
